import Vue from "vue";

if (document.getElementById("recovery-password-success")) {
  new Vue({
    name: "recoveryPasswordSuccess",
    el: "#recovery-password-success",
    data: {
      seconds: 10,
      interval: null,
      timer: null
    },
    computed: {},
    methods: {},
    mounted() {},
    created() {
      this.timer = setInterval(() => {
        if (this.seconds >= 1) {
          this.seconds = this.seconds - 1;
        } else {
          clearInterval(this.timer);
          window.location.replace("/user/login");
        }
      }, 1000);
    },
    mounted() {}
  });
}
